export default __webpack_public_path__ + "static/media/card.a1ae1050.svg";